module.exports = __webpack_public_path__ + "static/algoviz-444f15be5b3ea97f9145f8c76611a21c.svg";